import { RoutesV1 } from 'constants/appRoutes';
import { getAuth, getFunctionSupport, isNullOrEmpty } from 'functions';
import { getMenuAct } from 'model/actions/LoginAction';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkMenuExists } from 'utils';

function useConvertMenu() {
	const dispatch = useDispatch();
	const auth = getAuth();

	const loginRed = useSelector((state) => state.LoginReducer) || [];

	const functionSupportRed = useSelector(
		(state) => state.FunctionSupportReducer
	);

	const [menus, setMenu] = useState([]);
	const [menuActive, setMenuActive] = useState('/');
	const [dataFuncSupport, setDataFunctionSupport] = useState({});

	useEffect(() => {
		dispatch(getMenuAct());
	}, []);

	useEffect(() => {
		setMenuList();
	}, [loginRed, functionSupportRed]);

	// check show menu
	const isShowContract = checkMenuExists(RoutesV1.contractQuery, menus);
	// const isShowGift = checkMenuExists(RoutesV1.loyaltyStore, menus);
	const isShowGift = false;
	const isAdmin = !!auth?.admin;

	const setMenuList = () => {
		const auth = getAuth();
		let isAuth = !isNullOrEmpty(auth);
		let isCustomerAcc =
			isAuth && (auth.account === true || auth.group === true);
		let dataFuncSupport =
			functionSupportRed.resFuncSupport &&
			functionSupportRed.resFuncSupport.obj;

		let isEmptyDataFunc = isNullOrEmpty(dataFuncSupport);

		if (isEmptyDataFunc) {
			dataFuncSupport = getFunctionSupport();
			if (isCustomerAcc) {
				dataFuncSupport = auth;
			}
		}
		setDataFunctionSupport(dataFuncSupport);
		const menus = loginRed && loginRed.menus && loginRed.menus.obj;
		const menuData =
			menus &&
			menus.length &&
			menus.filter((item) => {
				if (isNullOrEmpty(dataFuncSupport)) {
					return item.menuId !== 'retrieve-contact';
				} else {
					return item;
				}
			});
		if (menuData) {
			setMenu(menuData);
		}
	};

	const menuFilter = menus.filter((item) => {
		if (item.menuPath === RoutesV1.contractQuery) return false;

		if (item.menuId === 'retrieve-contact') {
			if (item.children?.length === 0) return false;
			if (dataFuncSupport?.account === true) {
				if (item.children?.[0]?.menuId === 'group-product-view') return false;
			}
		}

		return true;
	});

	const checkRender = (dataFuncSupport, child) => {
		let isValid = false;
		if (dataFuncSupport.group === true && dataFuncSupport.account === true) {
			isValid = true;
		} else if (dataFuncSupport.group === true) {
			if (
				child.menuId === 'group-product-view' ||
				child.menuId === 'group-ebill' ||
				child.menuId === 'group-annual-report' ||
				child.menuId === 'online-trading'
			) {
				isValid = true;
			} else {
				isValid = false;
			}
		} else if (dataFuncSupport.account === true) {
			if (
				child.menuId === 'personal-product-view' ||
				child.menuId === 'view-e-bill' ||
				child.menuId === 'personal-annual-report' ||
				child.menuId === 'online-trading'
			) {
				isValid = true;
			} else {
				isValid = false;
			}
		}
		return isValid;
	};

	return {
		checkRender,
		setMenuList,
		menuFilter,
		dataFuncSupport,
		setMenuActive,
		menuActive,
		isShowContract,
		isShowGift,
		isAdmin,
	};
}

export default useConvertMenu;
